import React, { useState } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import { PAYMENT_METHODS } from "../../../utils/constants";
import "./PaymentMethodModal.scss";

// Selector de forma de pago (Efectivo / Tarjeta / Yape / Plin / Mixto) — lo usan el
// Cliente ("Pedir la cuenta") y el Admin ("Generar cuenta"). Reemplaza al
// ModalConfirm de dos botones de antes, que no daba para más de 2 opciones.
export function PaymentMethodModal(props) {
  const { show, title = "¿Cómo vas a pagar?", onSelect, onCancel } = props;
  // Solo el Admin/mozo, y solo si la facturación está activa (askDocument): el
  // comprobante que pide el cliente. Es un aviso para la Caja, que lo ve ya
  // elegido y lo puede cambiar. `customer` = el cliente puesto en la mesa.
  const { askDocument = false, customer } = props;
  const [docType, setDocType] = useState("NOTA");
  const hasRuc =
    customer?.doc_type === "RUC" && /^\d{11}$/.test(customer?.doc_number || "");
  const select = (method) => onSelect(method, askDocument ? docType : undefined);

  return (
    <Modal
      className="payment-method-modal"
      open={show}
      size="mini"
      onClose={onCancel}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        {askDocument && (
          <div className="payment-method-modal__doc">
            <label>Comprobante que pide el cliente</label>
            <Button.Group fluid size="small">
              {[
                ["NOTA", "Nota de venta"],
                ["BOLETA", "Boleta"],
                ["FACTURA", "Factura"],
              ].map(([value, text]) => (
                <Button
                  key={value}
                  type="button"
                  primary={docType === value}
                  basic={docType !== value}
                  onClick={() => setDocType(value)}
                >
                  {text}
                </Button>
              ))}
            </Button.Group>
            {docType === "FACTURA" && !hasRuc && (
              <p className="payment-method-modal__doc-warning">
                <Icon name="warning sign" /> Para factura, elige antes un cliente con RUC en la mesa.
              </p>
            )}
          </div>
        )}
        <div className="payment-method-modal__grid">
          {PAYMENT_METHODS.map((method) => (
            <Button
              key={method.value}
              basic
              size="large"
              onClick={() => select(method.value)}
            >
              <Icon name={method.icon} />
              {method.text}
            </Button>
          ))}
          {/* Mixto: solo avisa; el reparto (cuánto en cada forma) lo arma el
              mozo al cobrar, en "Cobrar cuenta". */}
          <Button
            basic
            size="large"
            className="payment-method-modal__mixed"
            onClick={() => select("MIXED")}
          >
            <Icon name="random" />
            Mixto
            <span>Una parte en una forma y el resto en otra; lo divides con el mozo al pagar.</span>
          </Button>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancelar</Button>
      </Modal.Actions>
    </Modal>
  );
}
